module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gQ35Z"))).then(() => parcelRequire('hEqeo'));